DotpaySubmit = function () {
    var init = function () {
        if (typeof gaSend === "function") {
            gaSend();
        }

        var btnSub = document.getElementById('submit_dotpay');

        if (btnSub === null || btnSub.length === 0) {
            return;
        }

        setTimeout(function () {
            btnSub.click();
        }, 5000);
    };

    return {
        init: function () {
            init();
        }
    };
}();
if (typeof (initDotpay) != "undefined") {
    DotpaySubmit.init();
}